import type { CityConfig } from "../city-template/types";

export const wilmingtonConfig: CityConfig = {
  city: "Wilmington",
  state: "North Carolina",
  stateAbbr: "NC",
  slug: "wilmington",
  route: "/cities/wilmington",
  title: "Emergency Passport Wilmington, NC — Expedited & Fast Passport Service | Fast Passport Center",
  metaDescription: "Emergency and expedited passport services in Wilmington, NC — as fast as 24 hours. Same-day courier processing available. A+ BBB rated, registered State Dept. courier serving New Hanover County and the Cape Fear Coast. Get your passport fast!",
  h1: "Emergency & Expedited Passport Services in Wilmington, NC",
  heroSubtitle: "Passport expired before your trip? Need an emergency passport fast? We help Wilmington and Cape Fear Coast travelers get their expedited passports as quickly as 24 hours. A+ BBB rated. No office visit required.",
  heroImageUrl: "https://readdy.ai/api/search-image?query=Beautiful%20coastal%20view%20of%20Wilmington%20North%20Carolina%20waterfront%20at%20golden%20hour%2C%20historic%20Riverwalk%20along%20the%20Cape%20Fear%20River%20with%20colorful%20boats%20and%20yachts%2C%20charming%20downtown%20buildings%20with%20warm%20sunset%20light%2C%20lush%20green%20coastal%20trees%2C%20calm%20river%20reflecting%20orange%20and%20pink%20sky%2C%20professional%20cityscape%20photography%20with%20vibrant%20warm%20colors%20and%20serene%20coastal%20atmosphere%2C%20no%20text%20or%20signs%20on%20buildings%2C%20clean%20modern%20waterfront%20scene&width=1800&height=700&seq=wilmington-hero-nc-001&orientation=landscape",
  heroImageAlt: "Wilmington North Carolina Riverwalk along the Cape Fear River at sunset",
  geoPosition: "34.2104;-77.8868",
  geoPlacename: "Wilmington, North Carolina",
  lastModified: "2026-07-21",
  regionalAgency: {
    name: "Washington DC Passport Agency",
    address: "600 19th St NW, Washington, DC 20006",
    distance: "Approximately 375 miles north of Wilmington — about 6 hours via I-95",
  },
  nearbyCitiesZips: [
    { name: "Wilmington", zips: "28401–28412" },
    { name: "Leland", zips: "28451" },
    { name: "Carolina Beach", zips: "28428" },
    { name: "Wrightsville Beach", zips: "28480" },
    { name: "Hampstead", zips: "28443" },
    { name: "Southport", zips: "28461, 28465" },
    { name: "Kure Beach", zips: "28449" },
    { name: "Castle Hayne", zips: "28429" },
    { name: "Ogden", zips: "28411" },
    { name: "Boiling Spring Lakes", zips: "28461" },
    { name: "Belville", zips: "28451" },
    { name: "Navassa", zips: "28451" },
  ],
  benefits: [
    { icon: "ri-time-line", title: "24–48 Hour Processing", desc: "Emergency courier submission for urgent Wilmington departures" },
    { icon: "ri-shield-check-line", title: "Registered Courier", desc: "U.S. Department of State approved passport expediting" },
    { icon: "ri-user-line", title: "Dedicated Agent", desc: "A real person assigned to your case from start to finish" },
    { icon: "ri-map-pin-2-line", title: "Cape Fear Coast Coverage", desc: "Serving New Hanover, Brunswick, and Pender counties" },
  ],
  internalLinks: [
    { name: "Expedited passport services in Charlotte, NC", route: "/cities/charlotte" },
    { name: "Fast passport renewal in Raleigh, NC", route: "/cities/raleigh" },
    { name: "Emergency passport help in Greensboro, NC", route: "/cities/greensboro" },
    { name: "Urgent passport services in Asheville, NC", route: "/cities/asheville" },
    { name: "Same-day passport help in Winston-Salem, NC", route: "/cities/winston-salem" },
    { name: "Passport courier services in Durham, NC", route: "/cities/durham" },
    { name: "Expedited passport services in Greenville, NC", route: "/cities/greenville" },
    { name: "Passport courier services in Leland, NC", route: "/cities/leland" },
  ],
  fpcOfficeNote: "Fast Passport Center serves Wilmington remotely via secure courier. We do not have a walk-in office in Wilmington — our registered couriers hand-deliver your documents directly to U.S. Department of State processing facilities. This is how we achieve 24–48 hour turnaround for New Hanover County and the Cape Fear Coast travelers.",
  fpcOfficeAddress: "301 Fayetteville St, Raleigh, North Carolina 27601",
  fpcOfficeDistance: "Serving all of New Hanover County and the Cape Fear Coast including Brunswick and Pender counties",
  serviceAreaIntro: "From downtown Wilmington to the beach communities of Wrightsville Beach and Carolina Beach, from Leland to Southport and Hampstead — Fast Passport Center serves the entire Cape Fear Coast region. We regularly help travelers from Kure Beach, Castle Hayne, and Boiling Spring Lakes get their passports fast.",
  nearbyCitiesIntro: "We serve all Wilmington neighborhoods and the surrounding Cape Fear Coast area including Leland, Carolina Beach, Wrightsville Beach, Hampstead, Southport, Kure Beach, Castle Hayne, Ogden, Boiling Spring Lakes, Belville, and Navassa. If you are anywhere in New Hanover, Brunswick, or Pender counties, we have you covered.",
  howItWorksIntro: "Most Wilmington travelers complete everything online and ship documents overnight. No need to drive to Washington DC or wait in line at the regional agency.",
  mistakesIntro: "Wilmington travelers often face long drives to the nearest regional passport agency. Here are the most common mistakes that cause delays.",
  testimonialsIntro: "Wilmington and Cape Fear Coast travelers trust us when their departure is days away. Here is what some of them have to say.",
  faqIntro: "Have questions about expedited passports in Wilmington? Here are the most common ones we hear from New Hanover County travelers.",
  statePageRoute: "/states/north-carolina",
  statePageName: "North Carolina",
  dmvWebsite: "https://www.ncdot.gov",
  dmvLabel: "North Carolina DMV — Official Website",
  stickyNavLinks: [
    { label: "Processing", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Service Area", href: "#service-area" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Comparison", href: "#comparison" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],
  processingOptions: [
    {
      speed: "2–9",
      unit: "Business Days",
      label: "Fast Passport Center",
      tag: "Most Popular",
      tagColor: "bg-[#F6C344] text-[#1A365D]",
      features: [
        "Registered U.S. Department of State Courier",
        "Reserved agency submission",
        "Predictable turnaround",
        "Ideal for upcoming trips",
        "Document review included",
        "Dedicated agent assigned to your case",
        "Daily status updates — never left guessing",
        "Not affected by government shutdowns",
      ],
      highlight: true,
    },
    {
      speed: "3–5",
      unit: "Weeks",
      label: "Fast Passport Center",
      tag: "Standard Expedited",
      tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
      features: [
        "Registered U.S. Department of State Courier",
        "Reserved agency submission",
        "Faster than self-service",
        "Good for planned travel",
        "Document review included",
        "Dedicated agent assigned to your case",
        "Daily status updates — never left guessing",
        "Not affected by government shutdowns",
      ],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "1–2",
      unit: "Months",
      label: "Self-Service (Post Office)",
      tag: "Slowest",
      tagColor: "bg-gray-100 text-gray-400",
      features: [
        "No courier access — standard mail only",
        "Workload & wait times shift with shutdowns",
        "In-person clerk appointment required",
        "No document review — errors cause rejection",
        "No dedicated agent — you are on your own",
        "Updates only by physical mail letter",
        "No phone or email contact for your case",
        "Can't upgrade speed after submission",
        "Not suitable if travel is within 10 weeks",
      ],
      highlight: false,
      muted: true,
    },
    {
      speed: "24",
      unit: "Hours*",
      label: "Regional Agency Processing",
      tag: "Emergency Only",
      tagColor: "bg-gray-100 text-gray-500",
      features: [
        "Appointment required — no walk-ins allowed",
        "Life-or-death emergencies only",
        "Bereavement or medical crisis",
        "Expect to wait all day or return next day",
      ],
      highlight: false,
      emergency: true,
    },
  ],
  services: [
    {
      icon: "ri-flashlight-line",
      title: "Emergency Passport",
      description: "For travelers with immediate departure needs — as fast as 24 hours for urgent Wilmington international flights.",
      bullets: ["24–48 hour turnaround available", "Registered courier hand-delivery", "Flight verification support"],
      badge: "Most Popular",
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-passport-line",
      title: "Passport Renewal",
      description: "Fast renewal for adults with a passport issued within the last 15 years at age 16 or older.",
      bullets: ["No clerk visit required for most", "Mail-in or courier options", "Lost passport replacement available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-add-circle-line",
      title: "New Passport",
      description: "First-time passport application guidance with acceptance clerk appointment support.",
      bullets: ["Acceptance facility locator", "Form DS-11 assistance", "Photo requirement guidance"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-alert-line",
      title: "Lost or Stolen Passport",
      description: "Passport replacement with DS-64 form guidance and police report documentation.",
      bullets: ["DS-64 form assistance", "Identity verification support", "Emergency replacement options"],
      badge: "Urgent",
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Passport services for minors under 16 with parental consent and acceptance clerk support.",
      bullets: ["DS-11 form for minors", "Parental consent guidance", "Both parents presence rules"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-file-edit-line",
      title: "Name Change",
      description: "Passport correction and name change service after marriage, divorce, or legal changes.",
      bullets: ["DS-5504 or DS-82 guidance", "Marriage certificate support", "Court order documentation"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport", description: "Urgent passport processing for travelers with immediate departure needs, as fast as 24 hours." },
    { name: "Passport Renewal", description: "Fast passport renewal for U.S. citizens with a passport issued within the last 15 years at age 16 or older." },
    { name: "New Passport", description: "First-time passport application assistance with step-by-step guidance through the acceptance clerk process." },
    { name: "Lost or Stolen Passport", description: "Passport replacement service for lost or stolen passports, including DS-64 form guidance." },
    { name: "Child Passport", description: "Passport services for minors under 16, with parental consent guidance and acceptance clerk support." },
    { name: "Name Change", description: "Passport correction and name change service after marriage, divorce, or legal name changes." },
  ],
  testimonials: [
    {
      name: "Sandra M.",
      location: "Wilmington, NC",
      rating: 5,
      text: "My passport expired the week before our cruise to the Bahamas. Fast Passport Center had my renewal in 4 days. Never had to leave the Cape Fear Coast. Outstanding service.",
      service: "Passport Renewal",
    },
    {
      name: "Chris P.",
      location: "Wrightsville Beach, NC",
      rating: 5,
      text: "Emergency passport for a family emergency in the UK. Got it in 32 hours. The team was incredibly responsive and compassionate. True lifesavers.",
      service: "Emergency Passport",
    },
    {
      name: "Amanda K.",
      location: "Leland, NC",
      rating: 5,
      text: "Business trip to Cancun came up with 5 days notice. They got me a passport in 3 business days. The communication was outstanding throughout the process.",
      service: "Emergency Passport",
    },
    {
      name: "David R.",
      location: "Carolina Beach, NC",
      rating: 5,
      text: "First passport for my son before his surf trip to Costa Rica. Fast Passport Center helped us navigate every step. Ready in 5 days with zero stress.",
      service: "Child Passport",
    },
  ],
  facilities: [
    {
      id: "wilmington-1",
      name: "Wilmington Main Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "251 N Front St",
      city: "Wilmington",
      state: "NC",
      zip: "28401",
      phone: "(910) 341-6211",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Downtown Wilmington",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Primary Wilmington facility. High volume — appointments strongly recommended. Call ahead to confirm passport acceptance.",
      icon: "ri-mail-line",
    },
    {
      id: "wilmington-2",
      name: "Leland Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "1121 Village Rd NE",
      city: "Leland",
      state: "NC",
      zip: "28451",
      phone: "(910) 383-2511",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "West of Wilmington, Brunswick County",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Convenient for Leland and Brunswick County residents. Less crowded than downtown.",
      icon: "ri-mail-line",
    },
    {
      id: "wilmington-3",
      name: "Carolina Beach Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "1101 N Lake Park Blvd",
      city: "Carolina Beach",
      state: "NC",
      zip: "28428",
      phone: "(910) 458-2511",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "South of Wilmington, beach area",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Carolina Beach and Kure Beach area. Full passport services. Appointments required.",
      icon: "ri-mail-line",
    },
    {
      id: "wilmington-4",
      name: "Southport Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "102 W Brown St",
      city: "Southport",
      state: "NC",
      zip: "28461",
      phone: "(910) 457-2511",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "South of Wilmington, Brunswick County",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Southport and Boiling Spring Lakes area. Call for appointment availability.",
      icon: "ri-mail-line",
    },
    {
      id: "wilmington-5",
      name: "New Hanover County Clerk of Court",
      type: "Court Clerk Passport Acceptance",
      address: "316 Princess St",
      city: "Wilmington",
      state: "NC",
      zip: "28401",
      phone: "(910) 341-1299",
      hours: "Mon–Fri: 8:00 AM – 5:00 PM",
      distance: "New Hanover County Courthouse, downtown Wilmington",
      website: "https://www.nhcgov.com/",
      websiteLabel: "New Hanover County Clerk",
      notes: "Accepts passport applications. Good alternative to post office with extended hours. Appointment recommended.",
      icon: "ri-government-line",
    },
    {
      id: "wilmington-6",
      name: "Hampstead Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "17179 US-17",
      city: "Hampstead",
      state: "NC",
      zip: "28443",
      phone: "(910) 270-2511",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "North of Wilmington, Pender County",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Hampstead and north Pender County area. Full passport services.",
      icon: "ri-mail-line",
    },
  ],
  comparisonRows: [
    { feature: "Appointment Needed", agency: "Yes — call NPIC, limited slots", fpc: "No — we handle everything for you" },
    { feature: "Processing Speed", agency: "Same-day if approved (rare)", fpc: "24–48 hours guaranteed for emergency" },
    { feature: "Document Review", agency: "No — rejected if wrong", fpc: "Yes — we check before submission" },
    { feature: "Travel to Agency", agency: "Yes — 6 hour drive to Washington DC", fpc: "No — ship from home or office" },
    { feature: "Agent Support", agency: "No — government clerk only", fpc: "Yes — dedicated agent assigned" },
    { feature: "Status Updates", agency: "No — no tracking provided", fpc: "Yes — daily email updates" },
    { feature: "Guaranteed Timing", agency: "No — subject to availability", fpc: "Yes — contractual turnaround times" },
  ],
  mistakes: [
    {
      icon: "ri-image-line",
      title: "Wrong Photo Size or Background",
      description: "Wilmington photo shops often use generic sizes. Passport photos must be exactly 2×2 inches with a white or off-white background.",
    },
    {
      icon: "ri-file-list-line",
      title: "Incomplete DS-11 Form",
      description: "Missing signatures or using the wrong form type are the #1 reasons for rejection at New Hanover County acceptance facilities.",
    },
    {
      icon: "ri-money-dollar-circle-line",
      title: "Wrong Payment Amount",
      description: "Fees change frequently. Many Wilmington applicants show up with incorrect payment and have to reschedule their appointment.",
    },
    {
      icon: "ri-calendar-close-line",
      title: "No Proof of Travel",
      description: "Without flight confirmation or travel itinerary, the regional agency will turn you away for emergency appointments.",
    },
    {
      icon: "ri-parent-line",
      title: "Missing Parental Consent",
      description: "For minors, both parents must appear or submit notarized consent. This trips up many New Hanover County families at the clerk.",
    },
    {
      icon: "ri-time-line",
      title: "Waiting Too Long to Start",
      description: "Wilmington travelers often assume standard processing will be fine. It takes 8–11 weeks. Start expedited at least 3 weeks before travel.",
    },
  ],
  steps: [
    { number: "1", icon: "ri-file-list-line", title: "Apply Online", description: "Complete your application on our secure website in under 10 minutes." },
    { number: "2", icon: "ri-mail-send-line", title: "Ship Documents", description: "We send you a prepaid overnight label. Drop your documents at any UPS location in Wilmington." },
    { number: "3", icon: "ri-shield-check-line", title: "We Review", description: "Our team checks every document for accuracy before hand-delivering to the State Department." },
    { number: "4", icon: "ri-passport-line", title: "Processing", description: "Your passport is processed at a U.S. Department of State facility using our registered courier slots." },
    { number: "5", icon: "ri-truck-line", title: "Delivery", description: "We overnight your new passport back to your Wilmington address — trackable every step of the way." },
  ],
  faqs: [
    { q: "Can I get an emergency passport in Wilmington before international travel?", a: "Yes. Fast Passport Center provides emergency passport services in Wilmington for travelers with urgent international flights. Our registered couriers hand-deliver your documents directly to U.S. Department of State facilities, achieving 24–48 hour turnaround — without the 6 hour drive to Washington DC." },
    { q: "How fast can I renew my passport in Wilmington?", a: "Fast Passport Center offers fast passport renewal in Wilmington in as little as 24–48 hours through our emergency courier service. For less urgent travel, our 3–5 day expedited option provides the best value. Both options include full document review and a dedicated agent." },
    { q: "What is the closest passport agency to Wilmington?", a: "The nearest regional passport agency to Wilmington is the Washington DC Passport Agency at 600 19th St NW, Washington DC 20006, approximately 375 miles north via I-95. For urgent processing without the long drive, Fast Passport Center's registered courier service achieves 24–48 hour turnaround from Wilmington without any in-person agency visit required." },
    { q: "Can I get a same-day passport appointment near Wilmington?", a: "Same-day passport appointments are only available at the Washington DC Passport Agency — approximately 6 hours from Wilmington — for documented life-or-death emergencies. For all other urgent travel, Fast Passport Center's 24–48 hour emergency courier processing is the fastest guaranteed option for New Hanover County residents." },
    { q: "Do you serve the beach communities?", a: "Absolutely. Fast Passport Center serves all of the Cape Fear Coast including Wilmington, Wrightsville Beach, Carolina Beach, Kure Beach, Leland, Southport, Hampstead, and Boiling Spring Lakes. Our courier service works seamlessly from any address in New Hanover, Brunswick, or Pender counties." },
    { q: "Can I expedite a child passport in Wilmington?", a: "Yes. Fast Passport Center expedites child passports in Wilmington for minors under 16. Both parents must appear or submit notarized consent, along with the child's birth certificate and both parents' IDs. We walk New Hanover County families through the entire process." },
    { q: "What should I do if I lost my passport before a trip?", a: "If you lost your passport before a trip, contact Fast Passport Center immediately. We provide lost passport replacement services in Wilmington with DS-64 form guidance and identity verification support. Our emergency courier service can get your replacement passport in 24–48 hours." },
    { q: "Do I need to drive to the Washington DC Passport Agency?", a: "No. With Fast Passport Center, you complete everything online and ship your documents overnight. Our couriers handle the in-person delivery to State Department facilities. You only need to visit a local acceptance clerk if you're a first-time applicant or need a name change." },
  ],
  photoLocations: [
    { name: "CVS Pharmacy — Downtown Wilmington", address: "1900 S 17th St, Wilmington, NC 28401", hours: "Mon–Sun: 8AM–10PM" },
    { name: "Walgreens — Wilmington", address: "4715 Market St, Wilmington, NC 28405", hours: "Mon–Sun: 7AM–11PM" },
    { name: "Walmart Supercenter — Wilmington", address: "5225 Sigmon Rd, Wilmington, NC 28403", hours: "Mon–Sun: 6AM–11PM" },
    { name: "FedEx Office — Wilmington", address: "1520 S 17th St, Wilmington, NC 28401", hours: "Mon–Fri: 7AM–9PM, Sat: 8AM–6PM" },
    { name: "CVS Pharmacy — Leland", address: "1120 Village Rd NE, Leland, NC 28451", hours: "Mon–Sun: 8AM–10PM" },
    { name: "Walgreens — Southport", address: "1650 N Howe St, Southport, NC 28461", hours: "Mon–Sun: 7AM–11PM" },
    { name: "CVS Pharmacy — Hampstead", address: "17185 US-17, Hampstead, NC 28443", hours: "Mon–Sun: 8AM–10PM" },
    { name: "Walmart — Leland", address: "108 Village Rd NE, Leland, NC 28451", hours: "Mon–Sun: 6AM–11PM" },
  ],
  dmvLocations: [
    {
      name: "NC DMV — Wilmington",
      address: "2390 Carolina Beach Rd, Wilmington, NC 28401",
      hours: "Mon–Fri: 8AM–5PM",
      note: "Driver's license and REAL ID services. Appointment recommended.",
      featured: true,
    },
    {
      name: "NC DMV — Leland",
      address: "1200 Magnolia Village Way, Leland, NC 28451",
      hours: "Mon–Fri: 8AM–5PM",
      note: "REAL ID and passport-related ID services. Appointment strongly recommended.",
      featured: false,
    },
    {
      name: "NC DMV — Hampstead",
      address: "16560 US-17, Hampstead, NC 28443",
      hours: "Mon–Fri: 8AM–5PM",
      note: "Serves Pender County and north New Hanover County residents. REAL ID available.",
      featured: false,
    },
    {
      name: "NC DMV — Southport",
      address: "1061 N Howe St, Southport, NC 28461",
      hours: "Mon–Fri: 8AM–5PM",
      note: "Serves Brunswick County. REAL ID available.",
      featured: true,
    },
  ],
  airports: [
    {
      code: "ILM",
      name: "Wilmington International Airport",
      distance: "5 miles northeast of downtown Wilmington",
      address: "1740 Airport Blvd, Wilmington, NC 28405",
      note: "Primary airport for the Cape Fear Coast. Direct flights to major domestic hubs including New York, Atlanta, and Charlotte. Seasonal international connections.",
      flightUrl: "https://www.flyilm.com/",
      flightLabel: "ILM Airport",
      featured: true,
    },
    {
      code: "RDU",
      name: "Raleigh-Durham International Airport",
      distance: "130 miles north of Wilmington",
      address: "2400 John Brantley Blvd, Morrisville, NC 27560",
      note: "Major alternative hub with additional international routes. Consider for long-haul international travel from the Cape Fear Coast.",
      flightUrl: "https://www.rdu.com/",
      flightLabel: "RDU Airport",
      featured: false,
    },
    {
      code: "CLT",
      name: "Charlotte Douglas International Airport",
      distance: "200 miles west of Wilmington",
      address: "5501 Josh Birmingham Pkwy, Charlotte, NC 28208",
      note: "Major international hub. American Airlines hub with direct flights to Europe, Mexico, and the Caribbean. Consider for international travel from the Cape Fear Coast.",
      flightUrl: "https://www.cltairport.com/",
      flightLabel: "CLT Airport",
      featured: false,
    },
  ],
  vitalRecordsLinks: [
    {
      label: 'North Carolina Vital Records (NCDHHS)',
      description: 'Birth and death certificates for all NC counties. Order online, by mail, or in person at the Raleigh office.',
      url: 'https://vitalrecords.nc.gov/',
    },
    {
      label: 'New Hanover County Register of Deeds',
      description: 'Marriage licenses and records for New Hanover County. Apply in person or request certified copies.',
      url: 'https://rod.nhcgov.com/',
    },
    {
      label: 'New Hanover County Clerk of Superior Court',
      description: 'Divorce records and decrees for New Hanover County. Contact the clerk for certified copies.',
      url: 'https://www.nccourts.gov/locations/new-hanover-county/new-hanover-county-clerk-of-superior-court',
    },
  ],
};